var refinement = require('./refinement');
var Number = require('./Number');

module.exports = refinement(Number, function (x) { return x % 1 === 0; }, 'Integer');



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/tcomb/lib/Integer.js
// module id = 2108
// module chunks = 69